import clsx from 'clsx';
import produce from 'immer';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { VirtuosoGrid } from 'react-virtuoso';
import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import ProgressChip from 'components/progress-chip';
import MeaningfulHeader from 'components/meaningful-header';
import ApartmentPlanListItem from 'components/apartment-plan-list-item';

import { BuyApartmentFlowPaths } from 'routes';
import useViewApartmentDealsButtonProps from 'hooks/use-view-apartment-deals-button-props';
import styles from './styles.module.scss';
import useApartmentsFilterLimitsOnboarding from '../../api/hooks/use-apartment-filter-limits-onboarding';
import useBoundStore from '../../store';

const ChooseApartmentPlan: React.FC = () => {
  const navigate = useNavigate();
  const { filterLimits } = useApartmentsFilterLimitsOnboarding();

  const setApartmentPlan = useBoundStore((s) => s.setApartmentPlan);

  const [plans, setPlans] = useState(filterLimits?.plans);

  const buttons: ButtonProps[] = [
    useViewApartmentDealsButtonProps(),
    {
      label: 'Продолжить',
      onClick: () => navigate(BuyApartmentFlowPaths.choosePriceRange),
    },
  ];

  const handleSelectPlan = (i: number, plan: any) => () => {
    const newPlans = produce(plans, (plans) => {
      if (!!plans) {
        plans[i].selected = !plans?.[i].selected;
      }
    });
    setPlans(newPlans);
    setApartmentPlan(plan?.id);
  };

  return (
    <BaseScreen
      buttons={buttons}
      noMarginForFloatingButtons
      fixedContentHeight
      title='Подбор объектов'
      footerClassName={styles.footer}
      onBackButtonClick={() => navigate(BuyApartmentFlowPaths.chooseNumberOfRooms)}
    >
      <MeaningfulHeader
        className={styles.header}
        header='Планировка'
        motto='Дом - это там, где находится сердце'
      />

      <VirtuosoGrid
        useWindowScroll
        context={{}}
        data={plans}
        style={{ height: '100%' }}
        className={styles.list}
        components={{}}
        itemContent={(i, plan) => (
          <ApartmentPlanListItem
            image={plan?.media?.url}
            selected={plan?.selected}
            onClick={handleSelectPlan(i, plan)}
            className={clsx(styles.apartmentPlanListItem)}
          />
        )}
      />
    </BaseScreen>
  );
};

export default ChooseApartmentPlan;
